/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Accept_BodyInputs */

const en_us2_draft_accept_body = /** @type {(inputs: Draft_Accept_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your current plan is archived and the new one starts at week 1. Your history stays.`)
};

const pt_br2_draft_accept_body = /** @type {(inputs: Draft_Accept_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano atual é arquivado e o novo recomeça na semana 1. O histórico continua.`)
};

const es_419_draft_accept_body = /** @type {(inputs: Draft_Accept_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan actual se archiva y el nuevo empieza en la semana 1. Tu historial se conserva.`)
};

const pt_pt2_draft_accept_body = /** @type {(inputs: Draft_Accept_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano atual é arquivado e o novo recomeça na semana 1. O histórico mantém-se.`)
};

const fr_fr2_draft_accept_body = /** @type {(inputs: Draft_Accept_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton programme actuel est archivé et le nouveau commence en semaine 1. Ton historique est conservé.`)
};

const de_de2_draft_accept_body = /** @type {(inputs: Draft_Accept_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein aktueller Plan wird archiviert und der neue beginnt in Woche 1. Dein Verlauf bleibt erhalten.`)
};

const it_it2_draft_accept_body = /** @type {(inputs: Draft_Accept_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda attuale viene archiviata e la nuova parte dalla settimana 1. Lo storico resta.`)
};

/**
* | output |
* | --- |
* | "Your current plan is archived and the new one starts at week 1. Your history stays." |
*
* @param {Draft_Accept_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_accept_body = /** @type {((inputs?: Draft_Accept_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Accept_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_accept_body(inputs)
	if (locale === "es-419") return es_419_draft_accept_body(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_accept_body(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_accept_body(inputs)
	if (locale === "de-DE") return de_de2_draft_accept_body(inputs)
	if (locale === "it-IT") return it_it2_draft_accept_body(inputs)
	return en_us2_draft_accept_body(inputs)
});
export { draft_accept_body as "draft.accept_body" }